const STORAGE_KEY = 'analytics_consent';
const GA_MEASUREMENT_ID = 'G-FY9P8XHQ44';

export function hasAnalyticsConsent() {
    try {
        const v = localStorage.getItem(STORAGE_KEY);
        if (v === 'true') return true;
        if (v === 'false') return false;
        return null;
    } catch (e) {
        return null;
    }
}

export function setAnalyticsConsent(value) {
    try {
        localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
    } catch (e) {
        // ignore
    }
}

export function loadGtag(id = GA_MEASUREMENT_ID) {
    if (typeof window === 'undefined' || !id) return Promise.resolve();

    if (window.gtag && window.__gaInitializedFor === id) return Promise.resolve();

    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);} // eslint-disable-line no-inner-declarations
    window.gtag = window.gtag || gtag;
    window.__gaInitializedFor = id;

    try {
        window.gtag('js', new Date());
        window.gtag('config', id, { anonymize_ip: true, send_page_view: false });
    } catch (e) {
        // ignore
    }

    const existing = document.querySelector(`script[src^="https://www.googletagmanager.com/gtag/js?id=${id}"]`);
    if (existing) {
        return new Promise((resolve) => {
            if (existing.getAttribute('data-ga-loaded') === 'true') return resolve();
            existing.addEventListener('load', () => resolve(), { once: true });
            existing.addEventListener('error', () => resolve(), { once: true });
        });
    }

    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
        script.addEventListener('load', () => {
            script.setAttribute('data-ga-loaded', 'true');
            resolve();
        }, { once: true });
        script.addEventListener('error', () => resolve(), { once: true });
        document.head.appendChild(script);
    });
}

export async function enableAnalytics() {
    setAnalyticsConsent(true);
    if (typeof window === 'undefined') return;
    try {
        await loadGtag(GA_MEASUREMENT_ID);
        sendPageView(window.location.pathname, document.title);
    } catch (e) {
        // ignore
    }
}

export function disableAnalytics() {
    setAnalyticsConsent(false);
    const cookies = ['_ga', '_gid', '_gat'];
    const domains = [window.location.hostname, '.' + window.location.hostname];
    cookies.forEach(name => {
        domains.forEach(domain => {
            document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`;
        });
    });
    document.cookie.split(';').forEach(c => {
        const name = c.trim().split('=')[0];
        if (name.startsWith('_ga_')) {
            domains.forEach(domain => {
                document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`;
            });
        }
    });
}

export function sendPageView(pathname, title) {
    if (hasAnalyticsConsent() !== true) return;
    try {
        window.gtag('event', 'page_view', { page_path: pathname, page_title: title });
    } catch (e) {
        // ignore
    }
}
